export const LINKS = {
  BOOK_DEMO: 'https://appt.link/codechum/call',
  LOGIN: 'https://app.codechum.com/login',
  SIGNUP: 'https://app.codechum.com/signup',
};
